<template>
  <div id="app">
    <div v-if="booting" class="startup-status" role="status" aria-live="polite">
      <div><i class="el-icon-loading"></i><p>正在加载页面和权限，请稍候…</p></div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    booting () {
      return !this.$route.matched.length || this.$store.state.access.status === 'loading'
    }
  }
}
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css"; /*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
.startup-status { position: fixed; inset: 0; z-index: 10000; display: flex; align-items: center; justify-content: center; background: #f5f7fa; text-align: center; color: #606266; }
.startup-status i { font-size: 28px; }
.startup-status p { margin-top: 16px; }
</style>



// WEBPACK FOOTER //
// src/App.vue